/* eslint-disable no-console */
import { register } from 'register-service-worker'

if (!('serviceWorker' in navigator)) {
  console.log('Service Worker not supported')
} else {
  console.log('Service Worker supported')
}

if (!('PushManager' in window)) {
  console.log('Push Manager not supported')
} else {
  console.log('Push Manager supported')
}

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('App is being served from cache by a service worker.')
    },
    registered() {
      console.log('Service worker has been registered.')
    },
    cached() {
      console.log('Content has been cached for offline use.')
      if (window.__showUpdateDownloading) {
        window.__onUpdateConfirm = () => {
          window.location.reload()
        }
        window.__showUpdateDownloading(
          'SweldoNow Ready',
          'You’re all set. Click OK to continue.'
        )
      }
    },
    updatefound() {
      console.log('New content is downloading.')
      
      if (window.__showUpdateDownloading) {
        window.__showUpdateDownloading(
          'Preparing SweldoNow',
          'Please wait while we get things ready. This may take a few seconds...'
        )
      }
    },
    updated(registration) {
      console.log('New content is available.')

      if (registration.waiting) {
        // Handle manual activation
        if (window.__showUpdateDownloading) {
          window.__onUpdateConfirm = () => {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' })
          }
          window.__showUpdateDownloading(
            'SweldoNow Ready',
            'You’re all set. Click OK to continue.'
          )
        }

        // Once activated, force reload
        registration.waiting.addEventListener('statechange', (event) => {
          if (event.target.state === 'activated') {
            window.location.reload()
          }
        })
      }
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
